import {Component, Input, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {ProductItemCardComponent} from "../../cards/product-item-card/product-item-card.component";
import {HttpService} from "../../../../core/services/http.service";
import {ProductService} from "../../../../core/services/marketplace/product.service";
import {ChallengeItemCardComponent} from "../../cards/challenge-item-card/challenge-item-card.component";
import {TranslateModule} from "@ngx-translate/core";
import {ServiceItemCardComponent} from "../../cards/service-item-card/service-item-card.component";
import {
  HorizontalCarouselComponent
} from "@white-label/components/carusels/horizontal-carousel/horizontal-carousel.component";
import {SafePipe} from "@cybfed/shared/pipes/safe.pipe";

@Component({
  selector: 'app-streamer-services',
  standalone: true,
  imports: [RouterOutlet, ProductItemCardComponent, ChallengeItemCardComponent, TranslateModule, ServiceItemCardComponent, HorizontalCarouselComponent, SafePipe],
  providers: [ProductService, HttpService],
  templateUrl: './streamer-services.component.html',
  styleUrl: './streamer-services.component.scss'
})
export class StreamerServicesComponent implements OnInit{
  title = 'cybfed-new-portal';
  filter:any = {
    next: null,
    previous: null,
    status: 'active',
    limit: 15
  };
  @Input() profileId: any;
  data: any = [];
  loading = false;

  constructor(private productService: ProductService) {
  }

  ngOnInit(): void {
    this.productService?.getItems({'productType[]': ['service', 'digital', 'physical']},{limit:10}).subscribe((data: any) =>{
      this.loading = true;
      if(!data.hasError){
        this.data = data.data.data;
        this.filter.next = data.data.next
      }
    })
  }

  contentData(){
    return [...this.data, ...this.data]
  }

}
